import store from '@/state/store'
//import { meta } from '@babel/eslint-parser';

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      title: 'Login',
      beforeResolve(next) {
        if (store.getters.loggedIn) {
          next({ name: 'dashboard' })
          next()
        } else {
          next()
        }
      }
    },
    component: () => import('../views/login.vue')
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard.vue"),
  },
  {
    path: "/branch",
    name: "branch",
    meta: {
      title: "Branch",
      authRequired: true,
    },
    component: () => import("../views/branch.vue"),
  },
  {
    path: "/activities",
    name: "activities",
    meta: {
      title: "Activities",
      authRequired: true,
    },
    component: () => import("../views/activities.vue"),
  },
  {
    path: "/pending-members",
    name: "pending-members",
    meta: {
      title: "Pending Patners",
      authRequired: true,
    },
    component: () => import("../views/partners/pending-members.vue"),
  },
  {
    path: "/member-activation/:code",
    name: "member-activation",
    meta: {
      title: "member-activation",
      authRequired: true,
    },
    component: () => import("../views/partners/member-activation.vue"),
  },

  {
    path: "/member-list",
    name: "member-list",
    meta: {
      title: "Partner List",
      authRequired: true,
    },
    component: () => import("../views/partners/member-list.vue"),
  },
  {
    path: "/member-history",
    name: "member-history",
    meta: {
      title: "Partner History",
      authRequired: true,
    },
    component: () => import("../views/partners/member-history.vue"),
  },
  {
    path: "/member-history/:code",
    name: "member-history-data",
    meta: {
      title: "Partner History",
      authRequired: true,
    },
    component: () => import("../views/partners/member-history-data.vue"),
  },
  {
    path: "/member-info/:code",
    name: "member-info",
    meta: {
      title: "Partner Info",
      authRequired: true,
    },
    component: () => import("../views/partners/member-info.vue"),
  },
  {
    path: "/recruitment",
    name: "Recruitment",
    meta: {
      title: "Recruitment",
      authRequired: true,
    },
    component: () => import("../views/partners/recruitment.vue"),
  },
  {
    path: "/recruitment/:code",
    name: "member-recruit",
    meta: {
      title: "Partner Recruit",
      authRequired: true,
    },
    component: () => import("../views/partners/member-recruit.vue"),
  },
  //Files and Links
  {
    path: "/files-and-links",
    name: "files-and-links",
    meta: {
      title: "Files and Links",
      authRequired: true,
    },
    component: () => import("../views/files-and-links.vue"),
  },
  //Property Listing
  {
    path: "/property-listing",
    name: "property-listing",
    meta: {
      title: "Property Listing",
      authRequired: true,
    },
    component: () => import("../views/listing/property-listing.vue"),
  },
  //ADD Property Listing
  {
    path: "/add-property-listing",
    name: "add-property-listing",
    meta: {
      title: "Add Property Listing",
      authRequired: true,
    },
    component: () => import("../views/listing/add-property-listing.vue"),
  },
  //Sales Production
  {
    path: "/developers",
    name: "developer",
    meta: {
      title: "Developers",
      authRequired: true,
    },
    component: () => import("../views/projects/developers.vue"),
  },
  {
    path: "/properties",
    name: "property",
    meta: {
      title: "Property/Project",
      authRequired: true,
    },
    component: () => import("../views/projects/properties.vue"),
  },
  {
    path: "/propert-comm-data",
    name: "propert-comm-data",
    meta: {
      title: "Commission Profile",
      authRequired: true,
    },
    component: () => import("../views/projects/property-commission.vue"),
  },
  {
    path: "/accounts-data",
    name: "accounts-data",
    meta: {
      title: "Accounts Data",
      authRequired: true,
    },
    component: () => import("../views/clients/accounts-data.vue"),
  },
  {
    path: "/accounts-profile-form",
    name: "accounts-profile-form",
    meta: {
      title: "Account Profile Form",
      authRequired: true,
    },
    component: () => import("../views/clients/account-profile-form.vue"),
  },
  //for updating account profile if redirect to new page
  // {
  //   path: "/update-account-profile/:id",
  //   name: "update-account-profile",
  //   meta: {
  //     title: "Update Account Profile Form",
  //     authRequired: true,
  //   },
  //   component: () => import("../views/accounting/update-account-profile.vue"),
  //   props: true, // IMPORTANT: Enables `id` as a prop
  // },

  // Services
  {
    path: "/services",
    name: "services",
    meta: {
      title: "Services",
      authRequired: true,
    },
    component: () => import("../views/services/services.vue"),
  },
  {
    path: "/documentation-list",
    name: "documentations list",
    meta: {
      title: "Documentations List",
      authRequired: true,
    },
    component: () => import("../views/services/documentations.vue"),
  },
  {
    path: "/documentation-data",
    name: "documentations data",
    meta: {
      title: "Documentations Data",
      authRequired: true,
    },
    component: () => import("../views/services/documentations-data.vue"),
  },
  // Accounting
  {
    path: "/expenses",
    name: "expenses",
    meta: {
      title: "Expenses",
      authRequired: true,
    },
    component: () => import("../views/accounting/expenses.vue"),
  },
  {
    path: "/cashin",
    name: "cashin",
    meta: {
      title: "Cash In",
      authRequired: true,
    },
    component: () => import("../views/accounting/cashin.vue"),
  },
  {
    path: "/computation",
    name: "computation",
    meta: {
      title: "Computation",
      authRequired: true,
    },
    component: () => import("../views/accounting/computation.vue"),
  },
  {
    path: "/cashout",
    name: "cashout",
    meta: {
      title: "Cash Out",
      authRequired: true,
    },
    component: () => import("../views/accounting/cashout.vue"),
  },
  // System
  {
    path: "/staff-list",
    name: "staff-list",
    meta: {
      title: "Staff List",
      authRequired: true,
    },
    component: () => import("../views/systems/staff-list.vue"),
  },
  {
    path: "/system-request",
    name: "system-request",
    meta: {
      title: "System Request",
      authRequired: true,
    },
    component: () => import("../views/system-request.vue"),
  },
  {
    path: "/staff-roles",
    name: "staff-roles",
    meta: {
      title: "System Roles",
      authRequired: true,
    },
    component: () => import("../views/systems/staff-roles.vue"),
  },
  {
    path: "/add-role",
    name: "add-role",
    meta: {
      title: "Add Roles",
      authRequired: true,
    },
    component: () => import("../views/systems/add-role.vue"),
  },
  {
    path: "/role-permission/:id",
    name: "role-permission",
    meta: {
      title: "Role Access",
      authRequired: true,
    },
    component: () => import("../views/systems/role-permissions.vue"),
  },
  {
    path: "/permissions/add",
    name: "add-role-permission",
    meta: {
      title: "Role Access",
      authRequired: true,
    },
    component: () => import("../views/systems/add-role.vue"),
  },
  {
    path: "/system-modules",
    name: "system-module",
    meta: {
      title: "System Module",
      authRequired: true,
    },
    component: () => import("../views/systems/system-module.vue"),
  },
  {
    path: "/activity-log",
    name: "activity-log",
    meta: {
      title: "Activity Log",
      authRequired: true,
    },
    component: () => import("../views/activity-log.vue"),
  },
  {
    path: "/user-log",
    name: "user-log",
    meta: {
      title: "User Log",
      authRequired: true,
    },
    component: () => import("../views/user-log.vue"),
  },
  {
    path: "/system-history",
    name: "system-history",
    meta: {
      title: "System History",
      authRequired: true,
    },
    component: () => import("../views/systems/system-history.vue"),
  },
  {
    path: "/rate-profiles",
    name: "rate-profile",
    meta: {
      title: "Rate Profile",
      authRequired: true,
    },
    component: () => import("../views/rate-profiles.vue"),
  },
  {
    path: "/pages/profile",
    name: "profile",
    meta: {
      title: "Profile",
      authRequired: true,
    },
    component: () => import("../views/profile.vue")
  },
  {
    path: "/pages/profile/reset-email",
    name: "reset-email",
    meta: {
      title: "reset email",
      authRequired: true,
    },
    component: () => import("../views/reset-password/reset-email.vue")
  },
  {
    path: "/pages/profile/reset-password",
    name: "reset-password",
    meta: {
      title: "reset password",
      authRequired: true,
    },
    component: () => import("../views/reset-password/reset-password.vue")
  },
];